export default {

  format: {
    message : "Please enter proper phone number.",
    fn      : (input)=> {
      if(!input) return true;
      return  Boolean(input.match(/(\+\d{1,3}\s?)?((\(\d{3}\)\s?)|(\d{3})(\s|-?))(\d{3}(\s|-?))(\d{4})(\s?(([E|e]xt[:|.|]?)|x|X)(\s?\d+))?/g));
    }
  }
}
